import xman from '@/common/xman';

export const viewMoreClick = (url: string) => {
  // fix xss
  if (/^https?:\/\//i.test(url) === false) return;
  if (!url) return;
  import(/* webpackChunkName: "MembershipDialogIframe" */ '@ali/membership-dialog-iframe').then(
    ({ default: MembershipDialogIframe }) => {
      const openDialog = () => {
        MembershipDialogIframe.show({
          url,
          hideCloseICon: true,
          iframeMessageCallback: (data, { close, setIframeLoaded }) => {
            const { eventType } = data || {};
            if (eventType === 'membership_dialog_to_login') {
              close && close();
              xman(() => openDialog());
            }
            if (typeof data === 'string') {
              try {
                const gmvPageData = JSON.parse(data) || {};
                if (gmvPageData.from !== 'buyerGmvChallenge') return;
                if (gmvPageData.event === 'ready') {
                  setIframeLoaded && setIframeLoaded(true);
                }
              } catch (e) {
                console.error(e);
              }
            }
            if (data?.event === 'closeDialogCheckout' && data?.from === 'checkout-standard-result')
              try {
                window.history.back();
              } catch (error) {
                console.log(error);
              }
          },
        });
      };
      openDialog();
    },
  );
};
